/* eslint-disable react/jsx-props-no-spreading */
import Svg from './svg';

const MinusIcon = (props) => (
  <Svg
    size={24}
    {...props}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="none"
    stroke="currentColor"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
  </Svg>
);

export default MinusIcon;
